export default {
    page_title: "Kevi | Campos del pedido",
    list: {
        title: "Campos del pedido",
        add_button: "Agregar",
        edit_tooltip: "Editar campo",
        delete_tooltip: "Eliminar campo",
    },
    form: {
        title: "Creando campo",
        name_label: "Nombre",
        type_label: "Tipo",
        options_label: "Opciones",
        option_placeholder: "Texto de la opción",
        option_label: "Opción {0}",
        remove_option: "Eliminar",
        add_option: "Agregar opción",
        back_button: "Volver",
        save_button: "Guardar",
    },
    edit_modal: {
        title: "Editar campo personalizado",
        name_label: "Nombre",
        type_label: "Tipo",
        options_label: "Opciones",
        option_placeholder: "Texto de la opción",
        option_label: "Opción {0}",
        remove_option: "Eliminar",
        add_option: "Agregar opción",
    },
    confirm_delete: {
        title: "¿Desea eliminar",
        no_relations:
            "Esta acción es irreversible, ¿está seguro de que desea continuar?",
        linked_automations: "las siguientes automatizaciones:",
        linked_segments: "los siguientes segmentos:",
        linked_warning: "Este campo está vinculado a",
        warning_message:
            "Se recomienda ajustar antes de eliminar, continuar ahora puede generar resultados inesperados.",
    },
    confirm_edit_name: {
        title: "¿Desea editar el nombre a",
        body: "Asegúrese de que el nuevo nombre es correcto antes de confirmar.",
    },
    notifications: {
        field_edited: "Campo de pedido editado",
        field_updated: "Campo actualizado",
        field_added: "Campo agregado",
        field_deleted: "Campo personalizado eliminado",
        min_options_warning: "Debe agregar al menos dos opciones completadas.",
    },
    sr: {
        name_label: "Nombre",
    },
};
